<template>
  <div class="app-voucher-input">
    <form v-on:submit.prevent>
      <fieldset>
        <legend class="visually-hidden">Code einlösen</legend>
        <div class="inputs-container">
          <div class="input-field">
            <label for="voucher-input" class="text-xl"
              ><slot name="lblInput">Geben Sie hier die Aufladennummer ein</slot></label
            >
            <ValidationIndicator :dirty="$v.voucherStr.$dirty" :valid="isValid('voucherStr')">
              <input
                id="voucher-input"
                name="voucher"
                type="text"
                class="input"
                required
                v-model="voucherStr"
                @blur="$v.voucherStr.$touch"
                @click="
                  $v.voucherStr.$reset()
                  voucherInvalid = false
                "
                :state="isValid('voucherStr')"
                :placeholder="placeholder"
                :class="{
                  'input--invalid': ($v.voucherStr.$invalid && $v.voucherStr.$dirty) || voucherInvalid,
                  'input--valid': !$v.voucherStr.$invalid && $v.voucherStr.$dirty
                }"
              />
            </ValidationIndicator>
            <p v-show="($v.voucherStr.$invalid && $v.voucherStr.$dirty) || voucherInvalid" class="text-error">
              Gib hier einen gültigen Aufladecode ein. Dieser muss zwischen 14 und 16 Zeichen lang sein.
            </p>
          </div>
          <button @click="save" class="button button--primary">
            <slot name="btnNext">Voucher einlösen</slot>
          </button>
        </div>
      </fieldset>
    </form>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import isValid from '@/mixins/isValid'
import { mapActions } from 'vuex'
import processSteps from '@/mixins/processSteps'
import { stepName as nextProcessStep } from './ThankYou.vue'
import transaction from '@/mixins/transaction'
import ValidationIndicator from '@/components-v2/generic/ValidationIndicator.vue'

export const stepName = 'input'

export default {
  name: 'VoucherInput',
  props: {
    placeholder: {
      type: String,
      default: 'Guthaben Code'
    }
  },
  components: {
    ValidationIndicator
  },
  mixins: [transaction('voucher'), validationMixin, isValid, processSteps(stepName, stepName, nextProcessStep)],
  data: function() {
    return {
      loading: false,
      voucherStr: '',
      voucherInvalid: false
    }
  },
  methods: {
    ...mapActions('topUp', ['sendVoucher']),
    reset() {
      this.voucherStr = ''
      this.$v.voucherStr.$reset()
    },
    async save() {
      if (!this.isValid('voucherStr')) {
        this.voucherInvalid = true
        return
      }

      this.loading = true
      await this.sendVoucher({
        voucher: this.voucherStr,
        nextStep: this.nextStep
      })
      this.loading = false
    }
  },
  validations() {
    return {
      voucherStr: {
        required,
        validateVoucher: this.$config?.validation?.validateVoucher || (voucher => true)
      }
    }
  }
}
</script>
